import './../css/GSideBar.css';
import './../css/GPostJob.css';
import './../css/GMediaQuery.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../CommonImports";

function GJobSingleRecentjobs() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
        <div className ="single-recent-jobs mt-4">
            <h4><span>Recent jobs</span></h4>
            <div className ="Glist-recent-jobs">
                <div className ="card-job hover-up wow animate__animated animate__fadeInUp">
                    <div className ="card-job-top d-flex">
                        <div className ="card-job-top--image">
                            <figure><figure>
                                <img alt="jobhub" src={mediaUrl + "digital.png?" + sasToken} className ="img-fluid" />
                            </figure>

                            </figure>
                        </div>
                        <div className ="card-job-top--info ms-3">
                            <h6 className ="card-job-top--info-heading"><a href="job-single.html">Digital
                                Experience Designer</a></h6>
                            <div className ="row">
                                <div className ="col-lg-7">
                                    <a href="employers-grid.html"><span
                                        className ="card-job-top--company">AliStudio, Inc</span></a>
                                    <span className ="card-job-top--location text-sm"><i
                                        className ="fi-rr-marker"></i> New York, NY</span>
                                    <span className ="card-job-top--type-job text-sm"><i
                                        className ="fi-rr-briefcase"></i> Full time</span>
                                    <span className ="card-job-top--post-time text-sm"><i
                                        className ="fi-rr-clock"></i> 3 mins ago</span>
                                </div>
                                <div className ="col-lg-5 text-lg-end">
                                    <span className ="card-job-top--price">$500<span>/Hour</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className ="card-job-description mt-3">
                        We want someone who has been doing this for a solid 2-3 years. We want someone
                        who can demonstrate an extremely strong portfolio. Create deliverables for your
                        product area (e.g., competitive analyses, user flows).
                    </div>
                    <div className ="card-job-bottom mt-3">
                        <div className ="row">
                            <div className ="col-lg-9 col-sm-8 col-12">
                                <a href="job-grid.html" className ="btn btn-sm btn-danger me-2">Urgent</a>
                                <a href="job-grid-2.html" className ="btn btn-sm btn-primary me-2">Senior</a>
                                <a href="job-grid.html" className ="btn btn-sm btn-secondary">Full time</a>
                            </div>
                            <div className ="col-lg-3 col-sm-4 col-12 text-end">
                                <span><img src={mediaUrl + "shield-check.svg?" + sasToken} alt="jobhub" /></span>

                                <span className ="ms-2"><img src={mediaUrl + "bookmark.svg?" + sasToken} alt="jobhub" /></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className ="Glist-recent-jobs">
                <div className ="card-job hover-up wow animate__animated animate__fadeInUp">
                    <div className ="card-job-top d-flex">
                        <div className ="card-job-top--image">
                            <figure>
                                <img alt="jobhub" src={mediaUrl + "digital.png?" + sasToken} className ="img-fluid" />
                            </figure>
                        </div>
                        <div className ="card-job-top--info ms-3">
                            <h6 className ="card-job-top--info-heading"><a href="job-single.html">Digital
                                Experience Designer</a></h6>
                            <div className ="row">
                                <div className ="col-lg-7">
                                    <a href="employers-grid.html"><span
                                        className ="card-job-top--company">AliStudio, Inc</span></a>
                                    <span className ="card-job-top--location text-sm"><i
                                        className ="fi-rr-marker"></i> New York, NY</span>
                                    <span className ="card-job-top--type-job text-sm"><i
                                        className ="fi-rr-briefcase"></i> Full time</span>
                                    <span className ="card-job-top--post-time text-sm"><i
                                        className ="fi-rr-clock"></i> 3 mins ago</span>
                                </div>
                                <div className ="col-lg-5 text-lg-end">
                                    <span className ="card-job-top--price">$500<span>/Hour</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className ="card-job-description mt-3">
                        We want someone who has been doing this for a solid 2-3 years. We want someone
                        who can demonstrate an extremely strong portfolio. Create deliverables for your
                        product area (e.g., competitive analyses, user flows).
                    </div>
                    <div className ="card-job-bottom mt-3">
                        <div className ="row">
                            <div className ="col-lg-9 col-sm-8 col-12">
                                <a href="job-grid.html" className ="btn btn-sm btn-danger me-2">Urgent</a>
                                <a href="job-grid-2.html" className ="btn btn-sm btn-primary me-2">Senior</a>
                                <a href="job-grid.html" className ="btn btn-sm btn-secondary">Full time</a>
                            </div>
                            <div className ="col-lg-3 col-sm-4 col-12 text-end">
                                <span><img src={mediaUrl + "shield-check.svg?" + sasToken} alt="jobhub" /></span>

                                <span className ="ms-2"><img src={mediaUrl + "bookmark.svg?" + sasToken} alt="jobhub" /></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className ="Glist-recent-jobs">
                <div className ="card-job hover-up wow animate__animated animate__fadeInUp">
                    <div className ="card-job-top d-flex">
                        <div className ="card-job-top--image">
                            <figure>
                                <img alt="jobhub" src={mediaUrl + "digital.png?" + sasToken} className ="img-fluid" />
                            </figure>
                        </div>
                        <div className ="card-job-top--info ms-3">
                            <h6 className ="card-job-top--info-heading"><a href="job-single.html">Digital
                                Experience Designer</a></h6>
                            <div className ="row">
                                <div className ="col-lg-7">
                                    <a href="employers-grid.html"><span
                                        className ="card-job-top--company">AliStudio, Inc</span></a>
                                    <span className ="card-job-top--location text-sm"><i
                                        className ="fi-rr-marker"></i> New York, NY</span>
                                    <span className ="card-job-top--type-job text-sm"><i
                                        className ="fi-rr-briefcase"></i> Full time</span>
                                    <span className ="card-job-top--post-time text-sm"><i
                                        className ="fi-rr-clock"></i> 3 mins ago</span>
                                </div>
                                <div className ="col-lg-5 text-lg-end">
                                    <span className ="card-job-top--price">$500<span>/Hour</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className ="card-job-description mt-3">
                        We want someone who has been doing this for a solid 2-3 years. We want someone
                        who can demonstrate an extremely strong portfolio. Create deliverables for your
                        product area (e.g., competitive analyses, user flows).
                    </div>
                    <div className ="card-job-bottom mt-3">
                        <div className ="row">
                            <div className ="col-lg-9 col-sm-8 col-12">
                                <a href="job-grid.html" className ="btn btn-sm btn-danger me-2">Urgent</a>
                                <a href="job-grid-2.html" className ="btn btn-sm btn-primary me-2">Senior</a>
                                <a href="job-grid.html" className ="btn btn-sm btn-secondary">Full time</a>
                            </div>
                            <div className ="col-lg-3 col-sm-4 col-12 text-end">
                                <span><img src={mediaUrl + "shield-check.svg?" + sasToken} alt="jobhub" /></span>

                                <span className ="ms-2"><img src={mediaUrl + "bookmark.svg?" + sasToken} alt="jobhub" /></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className ="Glist-recent-jobs">
                <div className ="card-job hover-up wow animate__animated animate__fadeInUp">
                    <div className ="card-job-top d-flex">
                        <div className ="card-job-top--image">
                            <figure>
                                <img alt="jobhub" src={mediaUrl + "digital.png?" + sasToken} className ="img-fluid" />
                            </figure>
                        </div>
                        <div className ="card-job-top--info ms-3">
                            <h6 className ="card-job-top--info-heading"><a href="job-single.html">Digital
                                Experience Designer</a></h6>
                            <div className ="row">
                                <div className ="col-lg-7">
                                    <a href="employers-grid.html"><span
                                        className ="card-job-top--company">AliStudio, Inc</span></a>
                                    <span className ="card-job-top--location text-sm"><i
                                        className ="fi-rr-marker"></i> New York, NY</span>
                                    <span className ="card-job-top--type-job text-sm"><i
                                        className ="fi-rr-briefcase"></i> Full time</span>
                                    <span className ="card-job-top--post-time text-sm"><i
                                        className ="fi-rr-clock"></i> 3 mins ago</span>
                                </div>
                                <div className ="col-lg-5 text-lg-end">
                                    <span className ="card-job-top--price">$500<span>/Hour</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className ="card-job-description mt-3">
                        We want someone who has been doing this for a solid 2-3 years. We want someone
                        who can demonstrate an extremely strong portfolio. Create deliverables for your
                        product area (e.g., competitive analyses, user flows).
                    </div>
                    <div className ="card-job-bottom mt-3">
                        <div className ="row">
                            <div className ="col-lg-9 col-sm-8 col-12">
                                <a href="job-grid.html" className ="btn btn-sm btn-danger me-2">Urgent</a>
                                <a href="job-grid-2.html" className ="btn btn-sm btn-primary me-2">Senior</a>
                                <a href="job-grid.html" className ="btn btn-sm btn-secondary">Full time</a>
                            </div>
                            <div className ="col-lg-3 col-sm-4 col-12 text-end">
                                <span><img src={mediaUrl + "shield-check.svg?" + sasToken} alt="jobhub" /></span>

                                <span className ="ms-2"><img src={mediaUrl + "bookmark.svg?" + sasToken} alt="jobhub" /></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className ="mb-3">
                <a href="job-grid.html" className ="btn btn-outline-primary">Explore more</a>
            </div>
        </div>

    )

}
export default GJobSingleRecentjobs;